import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "src/app/services/baseQuery";
export const api = createApi({
  baseQuery: baseQuery,
  tagTypes: [],
  endpoints: (build) => ({
    usersControllerCreate: build.mutation<
      UsersControllerCreateApiResponse,
      UsersControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users`,
        method: "POST",
        body: queryArg.adminUserCreateDto,
      }),
    }),
    usersControllerUpdate: build.mutation<
      UsersControllerUpdateApiResponse,
      UsersControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users`,
        method: "PUT",
        body: queryArg.adminUserUpdateDto,
      }),
    }),
    usersControllerFind: build.query<
      UsersControllerFindApiResponse,
      UsersControllerFindApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users`,
        params: {
          username: queryArg.username,
          firstName: queryArg.firstName,
          lastName: queryArg.lastName,
          email: queryArg.email,
          documentCount: queryArg.documentCount,
          companyId: queryArg.companyId,
          isManager: queryArg.isManager,
          tfaEnabled: queryArg.tfaEnabled,
        },
      }),
    }),
    usersControllerDelete: build.mutation<
      UsersControllerDeleteApiResponse,
      UsersControllerDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users`,
        method: "DELETE",
        body: queryArg.usernameDto,
      }),
    }),
    usersControllerCreateCompanyUser: build.mutation<
      UsersControllerCreateCompanyUserApiResponse,
      UsersControllerCreateCompanyUserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/company/users`,
        method: "POST",
        body: queryArg.companyUserCreateDto,
      }),
    }),
    usersControllerFindCompanyUsers: build.query<
      UsersControllerFindCompanyUsersApiResponse,
      UsersControllerFindCompanyUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/company/users`,
        params: {
          username: queryArg.username,
          firstName: queryArg.firstName,
          lastName: queryArg.lastName,
          email: queryArg.email,
          documentCount: queryArg.documentCount,
          isManager: queryArg.isManager,
          tfaEnabled: queryArg.tfaEnabled,
        },
      }),
    }),
    usersControllerGetUserProfile: build.query<
      UsersControllerGetUserProfileApiResponse,
      UsersControllerGetUserProfileApiArg
    >({
      query: () => ({ url: `/api/v1/users/profile` }),
    }),
    usersControllerUpdateUserProfile: build.mutation<
      UsersControllerUpdateUserProfileApiResponse,
      UsersControllerUpdateUserProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/profile`,
        method: "PATCH",
        body: queryArg.userUpdateDto,
      }),
    }),
    usersControllerSuspend: build.mutation<
      UsersControllerSuspendApiResponse,
      UsersControllerSuspendApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/suspend`,
        method: "PATCH",
        body: queryArg.usernameDto,
      }),
    }),
    usersControllerActivate: build.mutation<
      UsersControllerActivateApiResponse,
      UsersControllerActivateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/activate`,
        method: "POST",
        body: queryArg.usernameDto,
      }),
    }),
    usersControllerAssignRole: build.mutation<
      UsersControllerAssignRoleApiResponse,
      UsersControllerAssignRoleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/role`,
        method: "POST",
        body: queryArg.userRoleDto,
      }),
    }),
    usersControllerMailResetPassword: build.mutation<
      UsersControllerMailResetPasswordApiResponse,
      UsersControllerMailResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/mailResetPassword`,
        method: "POST",
        body: queryArg.mailResetPasswordDto,
      }),
    }),
    usersControllerCheckResetPasswordCred: build.query<
      UsersControllerCheckResetPasswordCredApiResponse,
      UsersControllerCheckResetPasswordCredApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/checkResetPasswordCred`,
        params: { resetCode: queryArg.resetCode, email: queryArg.email },
      }),
    }),
    usersControllerResetPassword: build.mutation<
      UsersControllerResetPasswordApiResponse,
      UsersControllerResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/resetPassword`,
        method: "POST",
        body: queryArg.changePasswordDto,
        params: { resetCode: queryArg.resetCode, email: queryArg.email },
      }),
    }),
    usersControllerChangePassword: build.mutation<
      UsersControllerChangePasswordApiResponse,
      UsersControllerChangePasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/changePassword`,
        method: "POST",
        body: queryArg.changeOwnPasswordDto,
      }),
    }),
    usersControllerConfirmEmailChange: build.mutation<
      UsersControllerConfirmEmailChangeApiResponse,
      UsersControllerConfirmEmailChangeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/email/confirm`,
        method: "POST",
        body: queryArg.confirmEmailChangeDto,
      }),
    }),
    usersControllerGetCompanies: build.query<
      UsersControllerGetCompaniesApiResponse,
      UsersControllerGetCompaniesApiArg
    >({
      query: () => ({ url: `/api/v1/users/company` }),
    }),
    usersControllerUpdateCompanyLicense: build.mutation<
      UsersControllerUpdateCompanyLicenseApiResponse,
      UsersControllerUpdateCompanyLicenseApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/update-company-limit`,
        method: "PATCH",
        body: queryArg.updateCompanyLimitDto,
      }),
    }),
    usersControllerGetCompanyUsers: build.query<
      UsersControllerGetCompanyUsersApiResponse,
      UsersControllerGetCompanyUsersApiArg
    >({
      query: () => ({ url: `/api/v1/users/my-company-users` }),
    }),
    usersControllerGetNotOwnerUsers: build.query<
      UsersControllerGetNotOwnerUsersApiResponse,
      UsersControllerGetNotOwnerUsersApiArg
    >({
      query: () => ({ url: `/api/v1/users/not-owner` }),
    }),
    companiesControllerFindAll: build.query<
      CompaniesControllerFindAllApiResponse,
      CompaniesControllerFindAllApiArg
    >({
      query: () => ({ url: `/api/v1/companies` }),
    }),
    companiesControllerCreate: build.mutation<
      CompaniesControllerCreateApiResponse,
      CompaniesControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/companies`,
        method: "POST",
        body: queryArg.companyCreateDto,
      }),
    }),
    companiesControllerDelete: build.mutation<
      CompaniesControllerDeleteApiResponse,
      CompaniesControllerDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/companies`,
        method: "DELETE",
        body: queryArg.idDto,
      }),
    }),
    authControllerLogin: build.mutation<
      AuthControllerLoginApiResponse,
      AuthControllerLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/auth`,
        method: "POST",
        body: queryArg.loginDto,
      }),
    }),
    authControllerSignup: build.mutation<
      AuthControllerSignupApiResponse,
      AuthControllerSignupApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/auth/signup`,
        method: "POST",
        body: queryArg.userCreateDto,
      }),
    }),
    twoFactorAuthControllerGenerateTwoFactor: build.query<
      TwoFactorAuthControllerGenerateTwoFactorApiResponse,
      TwoFactorAuthControllerGenerateTwoFactorApiArg
    >({
      query: () => ({ url: `/api/v1/tfa/generate-tfa` }),
    }),
    twoFactorAuthControllerEnableTwoFactor: build.mutation<
      TwoFactorAuthControllerEnableTwoFactorApiResponse,
      TwoFactorAuthControllerEnableTwoFactorApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tfa/enable-tfa`,
        method: "POST",
        body: queryArg.twoFactorDto,
      }),
    }),
    twoFactorAuthControllerDisableTwoFactor: build.mutation<
      TwoFactorAuthControllerDisableTwoFactorApiResponse,
      TwoFactorAuthControllerDisableTwoFactorApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tfa/disable-tfa`,
        method: "POST",
        body: queryArg.disableTwoFactorDto,
      }),
    }),
    twoFactorAuthControllerSendDisableTwoFactorCode: build.mutation<
      TwoFactorAuthControllerSendDisableTwoFactorCodeApiResponse,
      TwoFactorAuthControllerSendDisableTwoFactorCodeApiArg
    >({
      query: () => ({ url: `/api/v1/tfa/send-disable-code`, method: "POST" }),
    }),
    rolesControllerCreateRole: build.mutation<
      RolesControllerCreateRoleApiResponse,
      RolesControllerCreateRoleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/roles`,
        method: "POST",
        body: queryArg.roleDto,
      }),
    }),
    rolesControllerUpdateRole: build.mutation<
      RolesControllerUpdateRoleApiResponse,
      RolesControllerUpdateRoleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/roles`,
        method: "PUT",
        body: queryArg.updateRoleDto,
      }),
    }),
    rolesControllerReadRole: build.query<
      RolesControllerReadRoleApiResponse,
      RolesControllerReadRoleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/roles`,
        params: { roleId: queryArg.roleId },
      }),
    }),
    rolesControllerDeleteRole: build.mutation<
      RolesControllerDeleteRoleApiResponse,
      RolesControllerDeleteRoleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/roles`,
        method: "DELETE",
        body: queryArg.idDto,
      }),
    }),
    rolesControllerFindRole: build.query<
      RolesControllerFindRoleApiResponse,
      RolesControllerFindRoleApiArg
    >({
      query: () => ({ url: `/api/v1/roles/roles` }),
    }),
    mediaControllerUploadDocument: build.mutation<
      MediaControllerUploadDocumentApiResponse,
      MediaControllerUploadDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/media`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    workspacesControllerGetWorkspaceById: build.query<
      WorkspacesControllerGetWorkspaceByIdApiResponse,
      WorkspacesControllerGetWorkspaceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces`,
        params: { id: queryArg.id },
      }),
    }),
    workspacesControllerGetMyWorkspaces: build.query<
      WorkspacesControllerGetMyWorkspacesApiResponse,
      WorkspacesControllerGetMyWorkspacesApiArg
    >({
      query: () => ({ url: `/api/v1/workspaces/workspaces` }),
    }),
    workspacesControllerCreateWorkspace: build.mutation<
      WorkspacesControllerCreateWorkspaceApiResponse,
      WorkspacesControllerCreateWorkspaceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/workspace`,
        method: "POST",
        body: queryArg.createWorkspaceDto,
      }),
    }),
    workspacesControllerUpdateWorkspace: build.mutation<
      WorkspacesControllerUpdateWorkspaceApiResponse,
      WorkspacesControllerUpdateWorkspaceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/workspace`,
        method: "PATCH",
        body: queryArg.updateWorkspaceDto,
      }),
    }),
    workspacesControllerDeleteWorkspace: build.mutation<
      WorkspacesControllerDeleteWorkspaceApiResponse,
      WorkspacesControllerDeleteWorkspaceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/workspace`,
        method: "DELETE",
        body: queryArg.idDto,
      }),
    }),
    workspacesControllerGetCompanyWorkspaces: build.query<
      WorkspacesControllerGetCompanyWorkspacesApiResponse,
      WorkspacesControllerGetCompanyWorkspacesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/company-workspaces`,
        params: { companyId: queryArg.companyId },
      }),
    }),
    workspacesControllerInviteUserToWorkspace: build.mutation<
      WorkspacesControllerInviteUserToWorkspaceApiResponse,
      WorkspacesControllerInviteUserToWorkspaceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/invite-user`,
        method: "POST",
        body: queryArg.inviteUsersDto,
      }),
    }),
    workspacesControllerAssignWorkspaceRole: build.mutation<
      WorkspacesControllerAssignWorkspaceRoleApiResponse,
      WorkspacesControllerAssignWorkspaceRoleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/assign-workspace-role`,
        method: "PATCH",
        body: queryArg.assignWorkspaceRoleDto,
      }),
    }),
    workspacesControllerDeleteWorkspaceUser: build.mutation<
      WorkspacesControllerDeleteWorkspaceUserApiResponse,
      WorkspacesControllerDeleteWorkspaceUserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/delete-workspace-user`,
        method: "DELETE",
        body: queryArg.deleteWorkspaceUserDto,
      }),
    }),
    workspacesControllerFindWorkspaceUser: build.query<
      WorkspacesControllerFindWorkspaceUserApiResponse,
      WorkspacesControllerFindWorkspaceUserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/get-workspace-user`,
        params: { workspaceId: queryArg.workspaceId },
      }),
    }),
    workspacesControllerCreateNewFolder: build.mutation<
      WorkspacesControllerCreateNewFolderApiResponse,
      WorkspacesControllerCreateNewFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/create-folder`,
        method: "POST",
        body: queryArg.createNewFolderWorkspaceDto,
      }),
    }),
    workspacesControllerAddFolderTo: build.mutation<
      WorkspacesControllerAddFolderToApiResponse,
      WorkspacesControllerAddFolderToApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/add-folder-to-folder`,
        method: "POST",
        body: queryArg.addFolderToFolderDto,
      }),
    }),
    workspacesControllerRenameFolder: build.mutation<
      WorkspacesControllerRenameFolderApiResponse,
      WorkspacesControllerRenameFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/rename-folder`,
        method: "PATCH",
        body: queryArg.renameFolderWorkspaceDto,
      }),
    }),
    workspacesControllerGetFolderById: build.query<
      WorkspacesControllerGetFolderByIdApiResponse,
      WorkspacesControllerGetFolderByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/get-folder/${queryArg.workspaceId}/${queryArg.folderId}`,
      }),
    }),
    workspacesControllerGetRootFolder: build.query<
      WorkspacesControllerGetRootFolderApiResponse,
      WorkspacesControllerGetRootFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/get-root-folder/${queryArg.id}`,
      }),
    }),
    workspacesControllerRemoveFolder: build.mutation<
      WorkspacesControllerRemoveFolderApiResponse,
      WorkspacesControllerRemoveFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/remove-folder`,
        method: "PATCH",
        body: queryArg.removeFolderWorkspaceDto,
      }),
    }),
    workspacesControllerDeleteFolder: build.mutation<
      WorkspacesControllerDeleteFolderApiResponse,
      WorkspacesControllerDeleteFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/workspaces/delete-folder`,
        method: "DELETE",
        body: queryArg.removeFolderWorkspaceDto,
      }),
    }),
    tasksControllerGetTask: build.query<
      TasksControllerGetTaskApiResponse,
      TasksControllerGetTaskApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/tasks/task/${queryArg.id}` }),
    }),
    tasksControllerGetMyRemovedTasks: build.query<
      TasksControllerGetMyRemovedTasksApiResponse,
      TasksControllerGetMyRemovedTasksApiArg
    >({
      query: () => ({ url: `/api/v1/tasks/removed` }),
    }),
    tasksControllerGetArchive: build.query<
      TasksControllerGetArchiveApiResponse,
      TasksControllerGetArchiveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/archive`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          name: queryArg.name,
          ocr: queryArg.ocr,
          assignedToMe: queryArg.assignedToMe,
        },
      }),
    }),
    tasksControllerGetTaskProgress: build.mutation<
      TasksControllerGetTaskProgressApiResponse,
      TasksControllerGetTaskProgressApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/${queryArg.id}/progress`,
        method: "POST",
      }),
    }),
    tasksControllerProgressStream: build.query<
      TasksControllerProgressStreamApiResponse,
      TasksControllerProgressStreamApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/${queryArg.id}/progress/stream`,
      }),
    }),
    tasksControllerSetAssignee: build.mutation<
      TasksControllerSetAssigneeApiResponse,
      TasksControllerSetAssigneeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/assignee`,
        method: "PATCH",
        body: queryArg.assignTaskDto,
      }),
    }),
    tasksControllerRemove: build.mutation<
      TasksControllerRemoveApiResponse,
      TasksControllerRemoveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/remove`,
        method: "PATCH",
        body: queryArg.idDto,
      }),
    }),
    tasksControllerRestore: build.mutation<
      TasksControllerRestoreApiResponse,
      TasksControllerRestoreApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/restore`,
        method: "POST",
        body: queryArg.restoreTaskDto,
      }),
    }),
    tasksControllerEmptyTrash: build.mutation<
      TasksControllerEmptyTrashApiResponse,
      void
    >({
      query: () => ({
        url: `/api/v1/tasks/empty-trash`,
        method: "DELETE",
      }),
    }),
    tasksControllerDelete: build.mutation<
      TasksControllerDeleteApiResponse,
      TasksControllerDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks`,
        method: "DELETE",
        body: queryArg.idDto,
      }),
    }),
    tasksControllerDeleteCompanyTasks: build.mutation<
      TasksControllerDeleteCompanyTasksApiResponse,
      TasksControllerDeleteCompanyTasksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/delete-company-tasks`,
        method: "DELETE",
        params: { id: queryArg.id },
      }),
    }),
    tasksControllerRemoveMany: build.mutation<
      TasksControllerRemoveManyApiResponse,
      TasksControllerRemoveManyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/remove-many`,
        method: "PATCH",
        body: queryArg.idsDto,
      }),
    }),
    tasksControllerGetCompanyTasks: build.query<
      TasksControllerGetCompanyTasksApiResponse,
      TasksControllerGetCompanyTasksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/company-tasks`,
        params: { companyId: queryArg.companyId },
      }),
    }),
    tasksControllerAddItem: build.mutation<
      TasksControllerAddItemApiResponse,
      TasksControllerAddItemApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/item`,
        method: "POST",
        body: queryArg.addItemDto,
      }),
    }),
    tasksControllerDeleteItem: build.mutation<
      TasksControllerDeleteItemApiResponse,
      TasksControllerDeleteItemApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/item`,
        method: "DELETE",
        body: queryArg.deleteItemDto,
      }),
    }),
    tasksControllerAddCustomBox: build.mutation<
      TasksControllerAddCustomBoxApiResponse,
      TasksControllerAddCustomBoxApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/custom-box`,
        method: "POST",
        body: queryArg.addCustomBoxDto,
      }),
    }),
    tasksControllerGetItems: build.query<
      TasksControllerGetItemsApiResponse,
      TasksControllerGetItemsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/${queryArg.taskId}/${queryArg.pageNumber}/items`,
      }),
    }),
    tasksControllerUpdateBox: build.mutation<
      TasksControllerUpdateBoxApiResponse,
      TasksControllerUpdateBoxApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/box`,
        method: "PUT",
        body: queryArg.updateBoxDto,
      }),
    }),
    tasksControllerChangeRedactState: build.mutation<
      TasksControllerChangeRedactStateApiResponse,
      TasksControllerChangeRedactStateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/item-redact-state`,
        method: "PUT",
        body: queryArg.changeRedactStateDto,
      }),
    }),
    tasksControllerGetLastModifiedTasks: build.query<
      TasksControllerGetLastModifiedTasksApiResponse,
      TasksControllerGetLastModifiedTasksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/last-modified-tasks`,
        params: { numberOfTasks: queryArg.numberOfTasks },
      }),
    }),
    tasksControllerChangeVerify: build.mutation<
      TasksControllerChangeVerifyApiResponse,
      TasksControllerChangeVerifyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/verify`,
        method: "PUT",
        body: queryArg.verifyDto,
      }),
    }),
    tasksControllerGenerateOutput: build.mutation<
      TasksControllerGenerateOutputApiResponse,
      TasksControllerGenerateOutputApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/generate-output`,
        method: "PUT",
        body: queryArg.generateOutputDto,
      }),
    }),
    tasksControllerGetTasksState: build.query<
      TasksControllerGetTasksStateApiResponse,
      TasksControllerGetTasksStateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/tasks-state`,
        params: { ids: queryArg.ids },
      }),
    }),
    tasksControllerGetTaskOutputState: build.query<
      TasksControllerGetTaskOutputStateApiResponse,
      TasksControllerGetTaskOutputStateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/task-output-state`,
        params: { id: queryArg.id },
      }),
    }),
    tasksControllerSearch: build.query<
      TasksControllerSearchApiResponse,
      TasksControllerSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/search`,
        params: { taskId: queryArg.taskId, text: queryArg.text },
      }),
    }),
    tasksControllerGetPagesItems: build.query<
      TasksControllerGetPagesItemsApiResponse,
      TasksControllerGetPagesItemsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/${queryArg.taskId}/${queryArg.start}/${queryArg.end}/items`,
      }),
    }),
    tasksControllerGetTaskCurrentPage: build.query<
      TasksControllerGetTaskCurrentPageApiResponse,
      TasksControllerGetTaskCurrentPageApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/currentPage/${queryArg.taskId}`,
      }),
    }),
    tasksControllerSetTaskCurrentPage: build.mutation<
      TasksControllerSetTaskCurrentPageApiResponse,
      TasksControllerSetTaskCurrentPageApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/currentPage`,
        method: "PATCH",
        body: queryArg.setTaskCurrentPageDto,
      }),
    }),
    tasksControllerCreateLegalCode: build.mutation<
      TasksControllerCreateLegalCodeApiResponse,
      TasksControllerCreateLegalCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/legal-code`,
        method: "POST",
        body: queryArg.createLegalCodeDto,
      }),
    }),
    tasksControllerRemoveLegalCode: build.mutation<
      TasksControllerRemoveLegalCodeApiResponse,
      TasksControllerRemoveLegalCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/legal-code`,
        method: "PATCH",
        body: queryArg.removeLegalCodeDto,
      }),
    }),
    tasksControllerGetTaskPagesUrl: build.query<
      TasksControllerGetTaskPagesUrlApiResponse,
      TasksControllerGetTaskPagesUrlApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/tasks/pages/${queryArg.taskId}` }),
    }),
    tasksControllerGetTaskOutFileUrl: build.query<
      TasksControllerGetTaskOutFileUrlApiResponse,
      TasksControllerGetTaskOutFileUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/taskOutFile/${queryArg.taskId}/url`,
      }),
    }),
    tasksControllerRedactAll: build.mutation<
      TasksControllerRedactAllApiResponse,
      TasksControllerRedactAllApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/redact-all`,
        method: "PATCH",
        body: queryArg.redactAllDto,
      }),
    }),
    tasksControllerUnRedactAll: build.mutation<
      TasksControllerUnRedactAllApiResponse,
      TasksControllerUnRedactAllApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/un-redact-all`,
        method: "PATCH",
        body: queryArg.redactAllDto,
      }),
    }),
    tasksControllerChangeItemsRedactState: build.mutation<
      TasksControllerChangeItemsRedactStateApiResponse,
      TasksControllerChangeItemsRedactStateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/items-redact-state`,
        method: "PATCH",
        body: queryArg.itemsRedactStateDto,
      }),
    }),
    tasksInternalControllerGetPdf2ImgTask: build.mutation<
      TasksInternalControllerGetPdf2ImgTaskApiResponse,
      TasksInternalControllerGetPdf2ImgTaskApiArg
    >({
      query: () => ({ url: `/api/v1/tasks/internal/pdf2img`, method: "POST" }),
    }),
    tasksInternalControllerSetPdf2ImgTaskResult: build.mutation<
      TasksInternalControllerSetPdf2ImgTaskResultApiResponse,
      TasksInternalControllerSetPdf2ImgTaskResultApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/internal/pdf2img/result`,
        method: "POST",
        body: queryArg.pdf2ImgTaskResultDto,
      }),
    }),
    tasksInternalControllerGetAiTasks: build.mutation<
      TasksInternalControllerGetAiTasksApiResponse,
      TasksInternalControllerGetAiTasksApiArg
    >({
      query: () => ({ url: `/api/v1/tasks/internal/ai`, method: "POST" }),
    }),
    tasksInternalControllerSetAiTasks: build.mutation<
      TasksInternalControllerSetAiTasksApiResponse,
      TasksInternalControllerSetAiTasksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/internal/ai/result`,
        method: "POST",
        body: queryArg.aiResultDto,
      }),
    }),
    tasksInternalControllerSetAiRefineResult: build.mutation<
      unknown,
      { aiResultDto: AiResultDto }
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/internal/ai/refine-result`,
        method: "POST",
        body: queryArg.aiResultDto,
      }),
    }),
    tasksInternalControllerGetGeneratingTasks: build.mutation<
      TasksInternalControllerGetGeneratingTasksApiResponse,
      TasksInternalControllerGetGeneratingTasksApiArg
    >({
      query: () => ({
        url: `/api/v1/tasks/internal/get-generating-task`,
        method: "POST",
      }),
    }),
    tasksInternalControllerSetGeneratingTasks: build.mutation<
      TasksInternalControllerSetGeneratingTasksApiResponse,
      TasksInternalControllerSetGeneratingTasksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tasks/internal/set-generating-task-result`,
        method: "POST",
        body: queryArg.generatingResultDto,
      }),
    }),
    limitAndUsageControllerGetUsage: build.query<
      LimitAndUsageControllerGetUsageApiResponse,
      LimitAndUsageControllerGetUsageApiArg
    >({
      query: () => ({ url: `/api/v1/limit-and-usage/usage` }),
    }),
    limitAndUsageControllerGetCompanyUsage: build.query<
      LimitAndUsageControllerGetCompanyUsageApiResponse,
      LimitAndUsageControllerGetCompanyUsageApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/limit-and-usage/company-usage/${queryArg.id}`,
      }),
    }),
    limitAndUsageControllerGetMyUsage: build.query<
      LimitAndUsageControllerGetMyUsageApiResponse,
      LimitAndUsageControllerGetMyUsageApiArg
    >({
      query: () => ({ url: `/api/v1/limit-and-usage/my-usage` }),
    }),
    notificationControllerCreateMyCompanyNotification: build.mutation<
      NotificationControllerCreateMyCompanyNotificationApiResponse,
      NotificationControllerCreateMyCompanyNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notification/create/my-company`,
        method: "POST",
        body: queryArg.createCompanyNotificationDto,
      }),
    }),
    notificationControllerCreateNotification: build.mutation<
      NotificationControllerCreateNotificationApiResponse,
      NotificationControllerCreateNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notification/create/users`,
        method: "POST",
        body: queryArg.createNotificationDto,
      }),
    }),
    notificationControllerCreateCompanyNotification: build.mutation<
      NotificationControllerCreateCompanyNotificationApiResponse,
      NotificationControllerCreateCompanyNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notification/create/company/${queryArg.companyId}`,
        method: "POST",
        body: queryArg.createCompanyNotificationDto,
      }),
    }),
    notificationControllerGetAllNotification: build.query<
      NotificationControllerGetAllNotificationApiResponse,
      NotificationControllerGetAllNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notification/admin`,
        params: { to: queryArg.to },
      }),
    }),
    notificationControllerGetUnseenNotification: build.query<
      NotificationControllerGetUnseenNotificationApiResponse,
      NotificationControllerGetUnseenNotificationApiArg
    >({
      query: () => ({ url: `/api/v1/notification/user-unseen` }),
    }),
    notificationControllerGetPreviewUnseenNotification: build.query<
      NotificationControllerGetPreviewUnseenNotificationApiResponse,
      NotificationControllerGetPreviewUnseenNotificationApiArg
    >({
      query: () => ({ url: `/api/v1/notification/user-unseen-preview` }),
    }),
    notificationControllerGetUnseenNotificationCount: build.query<
      NotificationControllerGetUnseenNotificationCountApiResponse,
      NotificationControllerGetUnseenNotificationCountApiArg
    >({
      query: () => ({ url: `/api/v1/notification/user-unseen-count` }),
    }),
    notificationControllerGetNotification: build.query<
      NotificationControllerGetNotificationApiResponse,
      NotificationControllerGetNotificationApiArg
    >({
      query: () => ({ url: `/api/v1/notification/user` }),
    }),
    notificationControllerSeenNotification: build.mutation<
      NotificationControllerSeenNotificationApiResponse,
      NotificationControllerSeenNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notification/seen`,
        method: "POST",
        body: queryArg.idsDto,
      }),
    }),
    licenseControllerUploadLicense: build.mutation<
      LicenseControllerUploadLicenseApiResponse,
      LicenseControllerUploadLicenseApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/license`,
        method: "POST",
        body: queryArg.licenseDto,
      }),
    }),
    licenseControllerGetLicenseInformation: build.query<
      LicenseControllerGetLicenseInformationApiResponse,
      LicenseControllerGetLicenseInformationApiArg
    >({
      query: () => ({ url: `/api/v1/license` }),
    }),
    licenseControllerLicenseUpdate: build.mutation<
      LicenseControllerLicenseUpdateApiResponse,
      LicenseControllerLicenseUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/license`,
        method: "PUT",
        body: queryArg.updateCompanyDto,
      }),
    }),
    wordTaggerControllerCreate: build.mutation<
      WordTaggerControllerCreateApiResponse,
      WordTaggerControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/word-tagger`,
        method: "POST",
        body: queryArg.createWordDto,
      }),
    }),
    wordTaggerControllerFindAll: build.query<
      WordTaggerControllerFindAllApiResponse,
      WordTaggerControllerFindAllApiArg
    >({
      query: () => ({ url: `/api/v1/word-tagger` }),
    }),
    wordTaggerControllerFindMyWords: build.query<
      WordTaggerControllerFindMyWordsApiResponse,
      WordTaggerControllerFindMyWordsApiArg
    >({
      query: () => ({ url: `/api/v1/word-tagger/my-words` }),
    }),
    wordTaggerControllerFindOne: build.query<
      WordTaggerControllerFindOneApiResponse,
      WordTaggerControllerFindOneApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/word-tagger/word/${queryArg.id}` }),
    }),
    wordTaggerControllerUpdate: build.mutation<
      WordTaggerControllerUpdateApiResponse,
      WordTaggerControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/word-tagger/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateWordDto,
      }),
    }),
    wordTaggerControllerRemove: build.mutation<
      WordTaggerControllerRemoveApiResponse,
      WordTaggerControllerRemoveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/word-tagger/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    loggingControllerGetAllLogs: build.query<
      LoggingControllerGetAllLogsApiResponse,
      LoggingControllerGetAllLogsApiArg
    >({
      query: () => ({ url: `/api/v1/logging` }),
    }),
    loggingControllerGetAllUnsentLogs: build.query<
      LoggingControllerGetAllUnsentLogsApiResponse,
      LoggingControllerGetAllUnsentLogsApiArg
    >({
      query: () => ({ url: `/api/v1/logging/unsent` }),
    }),
    loggingControllerSendAllUnsentLogs: build.mutation<
      LoggingControllerSendAllUnsentLogsApiResponse,
      LoggingControllerSendAllUnsentLogsApiArg
    >({
      query: () => ({ url: `/api/v1/logging/send`, method: "POST" }),
    }),
    demoControllerUploadDemo: build.mutation<
      DemoControllerUploadDemoApiResponse,
      DemoControllerUploadDemoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/demo/upload`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    demoControllerQuickUploadDemo: build.mutation<
      DemoControllerQuickUploadDemoApiResponse,
      DemoControllerQuickUploadDemoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/demo/quick-upload`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    demoControllerStartDemo: build.mutation<
      DemoControllerStartDemoApiResponse,
      DemoControllerStartDemoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/demo/start`,
        method: "POST",
        body: queryArg.settingDto,
      }),
    }),
    demoControllerExchangeToken: build.mutation<
      DemoControllerExchangeTokenApiResponse,
      DemoControllerExchangeTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/demo/exchange-token`,
        method: "POST",
        body: queryArg.tokenDto,
      }),
    }),
    legalCodeControllerFindMy: build.query<
      LegalCodeControllerFindMyApiResponse,
      LegalCodeControllerFindMyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/legal-codes/my`,
        params: { locale: queryArg?.locale },
      }),
    }),
    legalCodeControllerCreate: build.mutation<
      LegalCodeControllerCreateApiResponse,
      LegalCodeControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/legal-codes`,
        method: "POST",
        body: queryArg.createCompanyLegalCodeDto,
      }),
    }),
    legalCodeControllerUpdate: build.mutation<
      LegalCodeControllerUpdateApiResponse,
      LegalCodeControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/legal-codes/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateCompanyLegalCodeDto,
      }),
    }),
    legalCodeControllerSetDefault: build.mutation<
      LegalCodeControllerSetDefaultApiResponse,
      LegalCodeControllerSetDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/legal-codes/${queryArg.id}/default`,
        method: "PATCH",
      }),
    }),
    legalCodeControllerRemove: build.mutation<
      LegalCodeControllerRemoveApiResponse,
      LegalCodeControllerRemoveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/legal-codes/${queryArg.id}`,
        method: "DELETE",
        params: {
          remapToDefault: queryArg.deleteCompanyLegalCodeDto?.remapToDefault,
        },
      }),
    }),
  }),
});
export type UsersControllerCreateApiResponse = /** status 201  */ UserRo;
export type UsersControllerCreateApiArg = {
  adminUserCreateDto: AdminUserCreateDto;
};
export type UsersControllerUpdateApiResponse = unknown;
export type UsersControllerUpdateApiArg = {
  adminUserUpdateDto: AdminUserUpdateDto;
};
export type UsersControllerFindApiResponse = /** status 200  */ UserRo[];
export type UsersControllerFindApiArg = {
  username?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  documentCount?: number;
  companyId?: string;
  isManager?: boolean;
  tfaEnabled?: boolean;
};
export type UsersControllerDeleteApiResponse = unknown;
export type UsersControllerDeleteApiArg = {
  usernameDto: UsernameDto;
};
export type UsersControllerCreateCompanyUserApiResponse =
  /** status 201  */ UserRo;
export type UsersControllerCreateCompanyUserApiArg = {
  companyUserCreateDto: CompanyUserCreateDto;
};
export type UsersControllerFindCompanyUsersApiResponse =
  /** status 200  */ UserRo[];
export type UsersControllerFindCompanyUsersApiArg = {
  username?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  documentCount?: number;
  isManager?: boolean;
  tfaEnabled?: boolean;
};
export type UsersControllerGetUserProfileApiResponse = /** status 200  */
  | UserRo
  | DemoProfileRo;
export type UsersControllerGetUserProfileApiArg = void;
export type UsersControllerUpdateUserProfileApiResponse = unknown;
export type UsersControllerUpdateUserProfileApiArg = {
  userUpdateDto: UserUpdateDto;
};
export type UsersControllerSuspendApiResponse = unknown;
export type UsersControllerSuspendApiArg = {
  usernameDto: UsernameDto;
};
export type UsersControllerActivateApiResponse = unknown;
export type UsersControllerActivateApiArg = {
  usernameDto: UsernameDto;
};
export type UsersControllerAssignRoleApiResponse = unknown;
export type UsersControllerAssignRoleApiArg = {
  userRoleDto: UserRoleDto;
};
export type UsersControllerMailResetPasswordApiResponse = unknown;
export type UsersControllerMailResetPasswordApiArg = {
  mailResetPasswordDto: MailResetPasswordDto;
};
export type UsersControllerCheckResetPasswordCredApiResponse = unknown;
export type UsersControllerCheckResetPasswordCredApiArg = {
  resetCode: string;
  email: string;
};
export type UsersControllerResetPasswordApiResponse = unknown;
export type UsersControllerResetPasswordApiArg = {
  resetCode: string;
  email: string;
  changePasswordDto: ChangePasswordDto;
};
export type UsersControllerChangePasswordApiResponse = unknown;
export type UsersControllerChangePasswordApiArg = {
  changeOwnPasswordDto: ChangeOwnPasswordDto;
};
export type UsersControllerConfirmEmailChangeApiResponse = unknown;
export type UsersControllerConfirmEmailChangeApiArg = {
  confirmEmailChangeDto: ConfirmEmailChangeDto;
};
export type UsersControllerGetCompaniesApiResponse =
  /** status 200  */ CompanyRo[];
export type UsersControllerGetCompaniesApiArg = void;
export type UsersControllerUpdateCompanyLicenseApiResponse = unknown;
export type UsersControllerUpdateCompanyLicenseApiArg = {
  updateCompanyLimitDto: UpdateCompanyLimitDto;
};
export type UsersControllerGetCompanyUsersApiResponse =
  /** status 200  */ UserRo[];
export type UsersControllerGetCompanyUsersApiArg = void;
export type UsersControllerGetNotOwnerUsersApiResponse =
  /** status 200  */ UserMinimalRo[];
export type UsersControllerGetNotOwnerUsersApiArg = void;
export type CompaniesControllerFindAllApiResponse =
  /** status 200  */ CompanyRo[];
export type CompaniesControllerFindAllApiArg = void;
export type CompaniesControllerCreateApiResponse = /** status 201  */ CompanyRo;
export type CompaniesControllerCreateApiArg = {
  companyCreateDto: CompanyCreateDto;
};
export type CompaniesControllerDeleteApiResponse = unknown;
export type CompaniesControllerDeleteApiArg = {
  idDto: IdDto;
};
export type AuthControllerLoginApiResponse = /** status 200  */ LoginRo;
export type AuthControllerLoginApiArg = {
  loginDto: LoginDto;
};
export type AuthControllerSignupApiResponse = /** status 201  */ SignupRo;
export type AuthControllerSignupApiArg = {
  userCreateDto: UserCreateDto;
};
export type TwoFactorAuthControllerGenerateTwoFactorApiResponse =
  /** status 200  */ TwoFactorRo;
export type TwoFactorAuthControllerGenerateTwoFactorApiArg = void;
export type TwoFactorAuthControllerEnableTwoFactorApiResponse = unknown;
export type TwoFactorAuthControllerEnableTwoFactorApiArg = {
  twoFactorDto: TwoFactorDto;
};
export type TwoFactorAuthControllerDisableTwoFactorApiResponse = unknown;
export type TwoFactorAuthControllerDisableTwoFactorApiArg = {
  disableTwoFactorDto: DisableTwoFactorDto;
};
export type TwoFactorAuthControllerSendDisableTwoFactorCodeApiResponse =
  unknown;
export type TwoFactorAuthControllerSendDisableTwoFactorCodeApiArg = void;
export type RolesControllerCreateRoleApiResponse = /** status 201  */ RoleRo;
export type RolesControllerCreateRoleApiArg = {
  roleDto: RoleDto;
};
export type RolesControllerUpdateRoleApiResponse = unknown;
export type RolesControllerUpdateRoleApiArg = {
  updateRoleDto: UpdateRoleDto;
};
export type RolesControllerReadRoleApiResponse = /** status 200  */ RoleRo;
export type RolesControllerReadRoleApiArg = {
  roleId: string;
};
export type RolesControllerDeleteRoleApiResponse = unknown;
export type RolesControllerDeleteRoleApiArg = {
  idDto: IdDto;
};
export type RolesControllerFindRoleApiResponse = /** status 200  */ RoleRo[];
export type RolesControllerFindRoleApiArg = void;
export type MediaControllerUploadDocumentApiResponse = /** status 200  */ IdRo;
export type MediaControllerUploadDocumentApiArg = {
  body: {
    file: Blob;
    pagesRanges: PagesRangeDto[];
    haveLegalCode: boolean;
    workspaceId: string;
    folderId?: string;
    description?: string;
    setting?: SettingDto;
  };
};
export type WorkspacesControllerGetWorkspaceByIdApiResponse =
  /** status 200  */ WorkspaceRo;
export type WorkspacesControllerGetWorkspaceByIdApiArg = {
  id: string;
};
export type WorkspacesControllerGetMyWorkspacesApiResponse =
  /** status 200  */ WorkspacePreviewRo[];
export type WorkspacesControllerGetMyWorkspacesApiArg = void;
export type WorkspacesControllerCreateWorkspaceApiResponse =
  /** status 200  */ string;
export type WorkspacesControllerCreateWorkspaceApiArg = {
  createWorkspaceDto: CreateWorkspaceDto;
};
export type WorkspacesControllerUpdateWorkspaceApiResponse =
  /** status 200  */ WorkspaceRo;
export type WorkspacesControllerUpdateWorkspaceApiArg = {
  updateWorkspaceDto: UpdateWorkspaceDto;
};
export type WorkspacesControllerDeleteWorkspaceApiResponse = unknown;
export type WorkspacesControllerDeleteWorkspaceApiArg = {
  idDto: IdDto;
};
export type WorkspacesControllerGetCompanyWorkspacesApiResponse =
  /** status 200  */ WorkspacePreviewRo[];
export type WorkspacesControllerGetCompanyWorkspacesApiArg = {
  companyId?: string;
};
export type WorkspacesControllerInviteUserToWorkspaceApiResponse =
  /** status 200  */ InviteUserRo[];
export type WorkspacesControllerInviteUserToWorkspaceApiArg = {
  inviteUsersDto: InviteUsersDto;
};
export type WorkspacesControllerAssignWorkspaceRoleApiResponse = unknown;
export type WorkspacesControllerAssignWorkspaceRoleApiArg = {
  assignWorkspaceRoleDto: AssignWorkspaceRoleDto;
};
export type WorkspacesControllerDeleteWorkspaceUserApiResponse = unknown;
export type WorkspacesControllerDeleteWorkspaceUserApiArg = {
  deleteWorkspaceUserDto: DeleteWorkspaceUserDto;
};
export type WorkspacesControllerFindWorkspaceUserApiResponse =
  /** status 200  */ WorkspaceUserRo;
export type WorkspacesControllerFindWorkspaceUserApiArg = {
  workspaceId: string;
};
export type WorkspacesControllerCreateNewFolderApiResponse =
  /** status 200  */ IdRo;
export type WorkspacesControllerCreateNewFolderApiArg = {
  createNewFolderWorkspaceDto: CreateNewFolderWorkspaceDto;
};
export type WorkspacesControllerAddFolderToApiResponse =
  /** status 200  */ IdRo;
export type WorkspacesControllerAddFolderToApiArg = {
  addFolderToFolderDto: AddFolderToFolderDto;
};
export type WorkspacesControllerRenameFolderApiResponse = unknown;
export type WorkspacesControllerRenameFolderApiArg = {
  renameFolderWorkspaceDto: RenameFolderWorkspaceDto;
};
export type WorkspacesControllerGetFolderByIdApiResponse =
  /** status 200  */ FolderRo;
export type WorkspacesControllerGetFolderByIdApiArg = {
  folderId: string;
  workspaceId: string;
};
export type WorkspacesControllerGetRootFolderApiResponse =
  /** status 200  */ FolderRo;
export type WorkspacesControllerGetRootFolderApiArg = {
  id: string;
};
export type WorkspacesControllerRemoveFolderApiResponse = unknown;
export type WorkspacesControllerRemoveFolderApiArg = {
  removeFolderWorkspaceDto: RemoveFolderWorkspaceDto;
};
export type WorkspacesControllerDeleteFolderApiResponse = unknown;
export type WorkspacesControllerDeleteFolderApiArg = {
  removeFolderWorkspaceDto: RemoveFolderWorkspaceDto;
};
export type TasksControllerGetTaskApiResponse = /** status 200  */ TaskRo;
export type TasksControllerGetTaskApiArg = {
  id: string;
};
export type TasksControllerGetMyRemovedTasksApiResponse =
  /** status 200  */ TaskRo[];
export type TasksControllerGetMyRemovedTasksApiArg = void;
export type TasksControllerGetArchiveApiResponse =
  /** status 200  */ ArchivePageRo;
export type TasksControllerGetArchiveApiArg = {
  page?: number;
  limit?: number;
  /** Case-insensitive filename / task name filter */
  name?: string;
  /** OCR full-text search across original box text */
  ocr?: string;
  /** When true, only return tasks assigned to the current user */
  assignedToMe?: boolean;
};
export type TasksControllerGetTaskProgressApiResponse =
  /** status 200  */ TaskProgressRo;
export type TasksControllerGetTaskProgressApiArg = {
  id: string;
};
export type TasksControllerProgressStreamApiResponse =
  /** status 200  */ TaskProgressRo;
export type TasksControllerProgressStreamApiArg = {
  id: string;
};
export type TasksControllerSetAssigneeApiResponse =
  /** status 200  */ TaskRo;
export type TasksControllerSetAssigneeApiArg = {
  assignTaskDto: AssignTaskDto;
};
export type TasksControllerRemoveApiResponse = unknown;
export type TasksControllerRemoveApiArg = {
  idDto: IdDto;
};
export type TasksControllerRestoreApiResponse = unknown;
export type TasksControllerRestoreApiArg = {
  restoreTaskDto: RestoreTaskDto;
};
export type TasksControllerEmptyTrashApiResponse = {
  purged: number;
};
export type TasksControllerDeleteApiResponse = unknown;
export type TasksControllerDeleteApiArg = {
  idDto: IdDto;
};
export type TasksControllerDeleteCompanyTasksApiResponse = unknown;
export type TasksControllerDeleteCompanyTasksApiArg = {
  id: string;
};
export type TasksControllerRemoveManyApiResponse = unknown;
export type TasksControllerRemoveManyApiArg = {
  idsDto: IdsDto;
};
export type TasksControllerGetCompanyTasksApiResponse =
  /** status 200  */ TaskRo[];
export type TasksControllerGetCompanyTasksApiArg = {
  companyId?: string;
};
export type TasksControllerAddItemApiResponse = /** status 200  */ ItemRo;
export type TasksControllerAddItemApiArg = {
  addItemDto: AddItemDto;
};
export type TasksControllerDeleteItemApiResponse = /** status 200  */ IdDto;
export type TasksControllerDeleteItemApiArg = {
  deleteItemDto: DeleteItemDto;
};
export type TasksControllerAddCustomBoxApiResponse = /** status 200  */ ItemRo;
export type TasksControllerAddCustomBoxApiArg = {
  addCustomBoxDto: AddCustomBoxDto;
};
export type TasksControllerGetItemsApiResponse = /** status 200  */ ItemsRo;
export type TasksControllerGetItemsApiArg = {
  taskId: string;
  pageNumber: number;
};
export type TasksControllerUpdateBoxApiResponse = unknown;
export type TasksControllerUpdateBoxApiArg = {
  updateBoxDto: UpdateBoxDto;
};
export type TasksControllerChangeRedactStateApiResponse = unknown;
export type TasksControllerChangeRedactStateApiArg = {
  changeRedactStateDto: ChangeRedactStateDto;
};
export type TasksControllerGetLastModifiedTasksApiResponse =
  /** status 200  */ TaskRo[];
export type TasksControllerGetLastModifiedTasksApiArg = {
  numberOfTasks: number;
};
export type TasksControllerChangeVerifyApiResponse = unknown;
export type TasksControllerChangeVerifyApiArg = {
  verifyDto: VerifyDto;
};
export type TasksControllerGenerateOutputApiResponse = unknown;
export type TasksControllerGenerateOutputApiArg = {
  generateOutputDto: GenerateOutputDto;
};
export type TasksControllerGetTasksStateApiResponse =
  /** status 200  */ TasksStateRo;
export type TasksControllerGetTasksStateApiArg = {
  ids: string[];
};
export type TasksControllerGetTaskOutputStateApiResponse =
  /** status 200  */ TaskOutputStateRo;
export type TasksControllerGetTaskOutputStateApiArg = {
  id: string;
};
export type TasksControllerSearchApiResponse = /** status 200  */ ItemsRo[];
export type TasksControllerSearchApiArg = {
  taskId: string;
  text: string;
};
export type TasksControllerGetPagesItemsApiResponse =
  /** status 200  */ ItemsRo[];
export type TasksControllerGetPagesItemsApiArg = {
  taskId: string;
  start: number;
  end: number;
};
export type TasksControllerGetTaskCurrentPageApiResponse =
  /** status 200  */ CurrentPageRo;
export type TasksControllerGetTaskCurrentPageApiArg = {
  taskId: string;
};
export type TasksControllerSetTaskCurrentPageApiResponse = unknown;
export type TasksControllerSetTaskCurrentPageApiArg = {
  setTaskCurrentPageDto: SetTaskCurrentPageDto;
};
export type TasksControllerCreateLegalCodeApiResponse = unknown;
export type TasksControllerCreateLegalCodeApiArg = {
  createLegalCodeDto: CreateLegalCodeDto;
};
export type TasksControllerRemoveLegalCodeApiResponse = unknown;
export type TasksControllerRemoveLegalCodeApiArg = {
  removeLegalCodeDto: RemoveLegalCodeDto;
};
export type TasksControllerGetTaskPagesUrlApiResponse =
  /** status 200  */ PageRo[];
export type TasksControllerGetTaskPagesUrlApiArg = {
  taskId: string;
};
export type TasksControllerGetTaskOutFileUrlApiResponse =
  /** status 200  */ UrlRo;
export type TasksControllerGetTaskOutFileUrlApiArg = {
  taskId: string;
};
export type TasksControllerRedactAllApiResponse = unknown;
export type TasksControllerRedactAllApiArg = {
  redactAllDto: RedactAllDto;
};
export type TasksControllerUnRedactAllApiResponse = unknown;
export type TasksControllerUnRedactAllApiArg = {
  redactAllDto: RedactAllDto;
};
export type TasksControllerChangeItemsRedactStateApiResponse = unknown;
export type TasksControllerChangeItemsRedactStateApiArg = {
  itemsRedactStateDto: ItemsRedactStateDto;
};
export type TasksInternalControllerGetPdf2ImgTaskApiResponse =
  /** status 200  */ Pdf2ImgTasksRo;
export type TasksInternalControllerGetPdf2ImgTaskApiArg = void;
export type TasksInternalControllerSetPdf2ImgTaskResultApiResponse = unknown;
export type TasksInternalControllerSetPdf2ImgTaskResultApiArg = {
  pdf2ImgTaskResultDto: Pdf2ImgTaskResultDto;
};
export type TasksInternalControllerGetAiTasksApiResponse =
  /** status 200  */ AiTasksRo[];
export type TasksInternalControllerGetAiTasksApiArg = void;
export type TasksInternalControllerSetAiTasksApiResponse = unknown;
export type TasksInternalControllerSetAiTasksApiArg = {
  aiResultDto: AiResultDto;
};
export type TasksInternalControllerGetGeneratingTasksApiResponse =
  /** status 200  */ PdfGeneratingTaskRo;
export type TasksInternalControllerGetGeneratingTasksApiArg = void;
export type TasksInternalControllerSetGeneratingTasksApiResponse = unknown;
export type TasksInternalControllerSetGeneratingTasksApiArg = {
  generatingResultDto: GeneratingResultDto;
};
export type LimitAndUsageControllerGetUsageApiResponse =
  /** status 200  */ UsageRo;
export type LimitAndUsageControllerGetUsageApiArg = void;
export type LimitAndUsageControllerGetCompanyUsageApiResponse =
  /** status 200  */ UsageRo;
export type LimitAndUsageControllerGetCompanyUsageApiArg = {
  id: string;
};
export type LimitAndUsageControllerGetMyUsageApiResponse =
  /** status 200  */ UsageRo;
export type LimitAndUsageControllerGetMyUsageApiArg = void;
export type NotificationControllerCreateMyCompanyNotificationApiResponse =
  /** status 201  */ NotificationRo[];
export type NotificationControllerCreateMyCompanyNotificationApiArg = {
  createCompanyNotificationDto: CreateCompanyNotificationDto;
};
export type NotificationControllerCreateNotificationApiResponse =
  /** status 201  */ NotificationRo[];
export type NotificationControllerCreateNotificationApiArg = {
  createNotificationDto: CreateNotificationDto;
};
export type NotificationControllerCreateCompanyNotificationApiResponse =
  /** status 201  */ NotificationRo[];
export type NotificationControllerCreateCompanyNotificationApiArg = {
  companyId: string;
  createCompanyNotificationDto: CreateCompanyNotificationDto;
};
export type NotificationControllerGetAllNotificationApiResponse =
  /** status 201  */ NotificationRo[];
export type NotificationControllerGetAllNotificationApiArg = {
  to: string[];
};
export type NotificationControllerGetUnseenNotificationApiResponse =
  /** status 201  */ NotificationRo[];
export type NotificationControllerGetUnseenNotificationApiArg = void;
export type NotificationControllerGetPreviewUnseenNotificationApiResponse =
  /** status 201  */ NotificationPreviewRo[];
export type NotificationControllerGetPreviewUnseenNotificationApiArg = void;
export type NotificationControllerGetUnseenNotificationCountApiResponse =
  /** status 201  */ NotificationCountRo;
export type NotificationControllerGetUnseenNotificationCountApiArg = void;
export type NotificationControllerGetNotificationApiResponse =
  /** status 201  */ NotificationRo[];
export type NotificationControllerGetNotificationApiArg = void;
export type NotificationControllerSeenNotificationApiResponse = unknown;
export type NotificationControllerSeenNotificationApiArg = {
  idsDto: IdsDto;
};
export type LicenseControllerUploadLicenseApiResponse =
  /** status 201  */ LicenseRo;
export type LicenseControllerUploadLicenseApiArg = {
  licenseDto: LicenseDto;
};
export type LicenseControllerGetLicenseInformationApiResponse =
  /** status 201  */ LicenseRo;
export type LicenseControllerGetLicenseInformationApiArg = void;
export type LicenseControllerLicenseUpdateApiResponse =
  /** status 201  */ string;
export type LicenseControllerLicenseUpdateApiArg = {
  updateCompanyDto: UpdateCompanyDto;
};
export type WordTaggerControllerCreateApiResponse = /** status 200  */ WordRo;
export type WordTaggerControllerCreateApiArg = {
  createWordDto: CreateWordDto;
};
export type WordTaggerControllerFindAllApiResponse =
  /** status 200  */ WordRo[];
export type WordTaggerControllerFindAllApiArg = void;
export type WordTaggerControllerFindMyWordsApiResponse =
  /** status 200  */ WordRo[];
export type WordTaggerControllerFindMyWordsApiArg = void;
export type WordTaggerControllerFindOneApiResponse = /** status 200  */ WordRo;
export type WordTaggerControllerFindOneApiArg = {
  id: string;
};
export type WordTaggerControllerUpdateApiResponse = unknown;
export type WordTaggerControllerUpdateApiArg = {
  id: string;
  updateWordDto: UpdateWordDto;
};
export type WordTaggerControllerRemoveApiResponse = unknown;
export type WordTaggerControllerRemoveApiArg = {
  id: string;
};
export type LoggingControllerGetAllLogsApiResponse =
  /** status 201  */ FallbackLogRo[];
export type LoggingControllerGetAllLogsApiArg = void;
export type LoggingControllerGetAllUnsentLogsApiResponse =
  /** status 201  */ FallbackLogRo[];
export type LoggingControllerGetAllUnsentLogsApiArg = void;
export type LoggingControllerSendAllUnsentLogsApiResponse = unknown;
export type LoggingControllerSendAllUnsentLogsApiArg = void;
export type DemoControllerUploadDemoApiResponse = unknown;
export type DemoControllerUploadDemoApiArg = {
  body: {
    file: Blob;
    pagesRanges: PagesRangeDto[];
    haveLegalCode: boolean;
    description?: string;
  };
};
export type DemoControllerQuickUploadDemoApiResponse = unknown;
export type DemoControllerQuickUploadDemoApiArg = {
  body: {
    file: Blob;
    pagesRanges: PagesRangeDto[];
    haveLegalCode: boolean;
    description?: string;
    setting?: SettingDto;
  };
};
export type DemoControllerStartDemoApiResponse = /** status 200  */ TokenDto;
export type DemoControllerStartDemoApiArg = {
  settingDto: SettingDto;
};
export type DemoControllerExchangeTokenApiResponse = /** status 200  */ DemoRo;
export type DemoControllerExchangeTokenApiArg = {
  tokenDto: TokenDto;
};
export type CompanyUsageRo = {
  maxUsers: number;
  maxPages: number;
  expirationTime: string;
};
export type UserDisplayRo = {
  name?: string;
  email?: string;
};
export type CompanyRo = {
  id: string;
  name: string;
  displayName?: string;
  createdAt?: string;
  owner: string;
  limit: CompanyUsageRo;
  userDisplay?: {
    [key: string]: UserDisplayRo;
  };
};
export type UserRo = {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  roleNames: string[];
  isActive: boolean;
  documentCount: number;
  company?: CompanyRo;
  isManager?: boolean;
  lastLogin: string;
  tfaEnabled?: boolean;
  tfaTempSecret?: string;
  requiresPasswordSetup?: boolean;
  usernameAutoGenerated?: boolean;
};
export type UserCreateDto = {
  username?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  email: string;
  companyName?: string;
  isManager: boolean;
  isActive: boolean;
  accountTier: "REGISTERED" | "DEMO";
};
export type AdminUserCreateDto = {
  username?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  email: string;
  /** @deprecated Deprecated for admin create: use companyId. */
  companyName?: string;
  isManager: boolean;
  isActive: boolean;
  accountTier: "REGISTERED" | "DEMO";
  companyId?: string;
};
export type AdminUserUpdateDto = {
  username: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  documentCount?: number;
  /** Company to move the user to, by ID. `null` removes the user from their company. Takes precedence over `companyName`. */
  companyId?: string | null;
  /** @deprecated Names are not unique. Use companyId. */
  companyName?: string;
  isManager?: boolean;
};
export type UsernameDto = {
  username: string;
};
export type CompanyUserCreateDto = {
  username?: string;
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  isManager?: boolean;
};
export type DemoFirstUploadTrimRo = {
  usedPages: number;
  totalPages: number;
};
export type DemoPropsRo = {
  usedDemoPages: number;
  demoPageLimit: number;
  usedRegisteredFreePages: number;
  registeredFreePageLimit: number;
  demoExpiresAt: string;
  firstUploadTrim?: DemoFirstUploadTrimRo;
};
export type DemoUserRo = {
  id: string;
  username: string;
  isActive: boolean;
  roleNames: string[];
  accountTier: "REGISTERED" | "DEMO";
  demo: DemoPropsRo;
};
export type DemoSourceRo = {
  src: string;
  med: string;
  cmp: string;
  ref: string;
  gclid: boolean;
};
export type DemoProfileRo = {
  id: string;
  username: string;
  isActive: boolean;
  roleNames: string[];
  accountTier: "REGISTERED" | "DEMO";
  demo: DemoPropsRo;
  demoSource?: DemoSourceRo;
};
export type UserUpdateDto = {
  username: string;
  firstName?: string;
  lastName?: string;
  email?: string;
};
export type UserRoleDto = {
  username: string;
  roleIds: string[];
};
export type MailResetPasswordDto = {
  email: string;
  callbackUrl: string;
};
export type ConfirmEmailChangeDto = {
  token: string;
};
export type ChangePasswordDto = {
  password: string;
};
export type ChangeOwnPasswordDto = {
  password: string;
  currentPassword?: string;
};
export type UpdateCompanyLimitDto = {
  id: string;
  maxUsers: number;
  maxPages: number;
  expirationTime: string;
};
export type UserMinimalRo = {
  username: string;
  firstName: string;
  lastName: string;
};
export type CompanyCreateDto = {
  companyName: string;
  owner: string;
};
export type IdDto = {
  id: string;
};
export type UserLoginRo = {
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  roleNames: string[];
  isActive: boolean;
  documentCount: number;
  isManager?: boolean;
  tfaEnabled?: boolean;
  requiresPasswordSetup?: boolean;
  usernameAutoGenerated?: boolean;
};
export type LoginRo = {
  token: string;
  user: UserLoginRo;
};
export type SignupRo = {
  user: UserLoginRo;
  userKey: string;
  handoff: string;
};
export type LoginDto = {
  username: string;
  identifier?: string;
  password: string;
  twoFactorToken: string;
};
export type TwoFactorRo = {
  otpauthUrl: string;
  qrCode: string;
};
export type TwoFactorDto = {
  token: string;
};
export type DisableTwoFactorDto = {
  tfaCode: string;
  emailCode: string;
};
export type RoleRo = {
  id: string;
  name: string;
  permissions:
    | "ADMIN"
    | "MANAGER"
    | "GET_GENERATING_TASKS"
    | "GET_TASK_BY_ID"
    | "PDF2IMG"
    | "CREATE_USER"
    | "UPDATE_USER"
    | "FIND_USER"
    | "GET_USER_BY_ID"
    | "DELETE_USER"
    | "SUSPEND_USER"
    | "ACTIVATE_USER"
    | "ASSIGN_ROLE"
    | "GET_MY_COMPANY_USERS"
    | "CREATE_WORKSPACE"
    | "DELETE_WORKSPACE"
    | "GET_WORKSPACE_BY_ID"
    | "GET_MY_COMPANY_WORKSPACES"
    | "UPDATE_WORKSPACE"
    | "GET_ALL_COMPANIES"
    | "CREATE_COMPANY"
    | "DELETE_COMPANY"
    | "UPDATE_COMPANY_LIMIT"
    | "GET_COMPANY_TASKS"
    | "GET_COMPANY_USAGE"
    | "GET_TASK_ITEMS"
    | "ADD_TASK_ITEMS"
    | "ADD_TASK_BOXES"
    | "MODIFY_TASK_ITEM"
    | "GENERATE_TASK_OUTPUT"
    | "DELETE_TASK_BY_ID"
    | "DELETE_COMPANY_TASKS"
    | "UPDATE_WORD"
    | "DELETE_WORD"
    | "CREATE_NOTIFICATION_TO_MY_COMPANY"
    | "CREATE_NOTIFICATION_TO_USER"
    | "NOT_DEMO";
};
export type RoleDto = {
  name: string;
  permissions: (
    | "ADMIN"
    | "MANAGER"
    | "GET_GENERATING_TASKS"
    | "GET_TASK_BY_ID"
    | "PDF2IMG"
    | "CREATE_USER"
    | "UPDATE_USER"
    | "FIND_USER"
    | "GET_USER_BY_ID"
    | "DELETE_USER"
    | "SUSPEND_USER"
    | "ACTIVATE_USER"
    | "ASSIGN_ROLE"
    | "GET_MY_COMPANY_USERS"
    | "CREATE_WORKSPACE"
    | "DELETE_WORKSPACE"
    | "GET_WORKSPACE_BY_ID"
    | "GET_MY_COMPANY_WORKSPACES"
    | "UPDATE_WORKSPACE"
    | "GET_ALL_COMPANIES"
    | "CREATE_COMPANY"
    | "DELETE_COMPANY"
    | "UPDATE_COMPANY_LIMIT"
    | "GET_COMPANY_TASKS"
    | "GET_COMPANY_USAGE"
    | "GET_TASK_ITEMS"
    | "ADD_TASK_ITEMS"
    | "ADD_TASK_BOXES"
    | "MODIFY_TASK_ITEM"
    | "GENERATE_TASK_OUTPUT"
    | "DELETE_TASK_BY_ID"
    | "DELETE_COMPANY_TASKS"
    | "UPDATE_WORD"
    | "DELETE_WORD"
    | "CREATE_NOTIFICATION_TO_MY_COMPANY"
    | "CREATE_NOTIFICATION_TO_USER"
    | "NOT_DEMO"
  )[];
};
export type UpdateRoleDto = {
  id: string;
  name: string;
  permissions: (
    | "ADMIN"
    | "MANAGER"
    | "GET_GENERATING_TASKS"
    | "GET_TASK_BY_ID"
    | "PDF2IMG"
    | "CREATE_USER"
    | "UPDATE_USER"
    | "FIND_USER"
    | "GET_USER_BY_ID"
    | "DELETE_USER"
    | "SUSPEND_USER"
    | "ACTIVATE_USER"
    | "ASSIGN_ROLE"
    | "GET_MY_COMPANY_USERS"
    | "CREATE_WORKSPACE"
    | "DELETE_WORKSPACE"
    | "GET_WORKSPACE_BY_ID"
    | "GET_MY_COMPANY_WORKSPACES"
    | "UPDATE_WORKSPACE"
    | "GET_ALL_COMPANIES"
    | "CREATE_COMPANY"
    | "DELETE_COMPANY"
    | "UPDATE_COMPANY_LIMIT"
    | "GET_COMPANY_TASKS"
    | "GET_COMPANY_USAGE"
    | "GET_TASK_ITEMS"
    | "ADD_TASK_ITEMS"
    | "ADD_TASK_BOXES"
    | "MODIFY_TASK_ITEM"
    | "GENERATE_TASK_OUTPUT"
    | "DELETE_TASK_BY_ID"
    | "DELETE_COMPANY_TASKS"
    | "UPDATE_WORD"
    | "DELETE_WORD"
    | "CREATE_NOTIFICATION_TO_MY_COMPANY"
    | "CREATE_NOTIFICATION_TO_USER"
    | "NOT_DEMO"
  )[];
};
export type IdRo = {
  id: string;
};
export type PagesRangeDto = {
  from: number;
  to: number;
};
export type SettingDto = {
  language: "EN" | "NL" | "FR" | "IT" | "DE" | "ES" | "PT" | "ZHS" | "ZHT";
  autoRedactTags: (
    | "PERSON"
    | "LOCATION"
    | "ORGANIZATION"
    | "PHONE"
    | "EMAIL"
    | "DATE"
    | "NAME"
    | "LINK"
    | "BSN"
    | "IBAN"
    | "SIGNATURE"
  )[];
  setLegalCode: boolean;
};
export type UrlRo = {
  url: string;
};
export type SettingRo = {
  language: "EN" | "NL" | "FR" | "IT" | "DE" | "ES" | "PT" | "ZHS" | "ZHT";
  autoRedactTags: (
    | "PERSON"
    | "LOCATION"
    | "ORGANIZATION"
    | "PHONE"
    | "EMAIL"
    | "DATE"
    | "NAME"
    | "LINK"
    | "BSN"
    | "IBAN"
    | "SIGNATURE"
  )[];
  setLegalCode: boolean;
};
export type WorkspaceRo = {
  id: string;
  name: string;
  creator: string;
  companyId: string;
  workspaceUsers: string[];
  workspaceMaintainers: string[];
  folderId: string;
  description: string;
  defaultSetting: SettingRo;
  createdAt: string;
  color?: string | null;
  memberEmails?: {
    [key: string]: string;
  };
  userDisplay?: {
    [key: string]: UserDisplayRo;
  };
};
export type WorkspacePreviewRo = {
  id: string;
  name: string;
  creator: string;
  usersCount: number;
  foldersCount: number;
  tasksCount: number;
  description: string;
  state:
    | "CREATE_IMAGES"
    | "CREATING_IMAGES"
    | "PENDING"
    | "PROCESSING"
    | "PREPARING"
    | "PARTIAL_READY"
    | "READY"
    | "READY_WITH_ERRORS"
    | "ERROR";
  createdAt: string;
  color?: string | null;
  userDisplay?: {
    [key: string]: UserDisplayRo;
  };
};
export type CreateWorkspaceDto = {
  name: string;
  workspaceUsers: string[];
  isCompanyLevel: boolean;
  description?: string;
  defaultSetting: SettingDto;
};
export type UpdateWorkspaceDto = {
  id: string;
  name: string;
  description?: string;
  defaultSetting: SettingDto;
  color?: string | null;
};
export type InviteUserRo = {
  username: string;
  access: ("WORKSPACE_MANAGER" | "WORKSPACE_USER")[];
};
export type InviteUsersDto = {
  workspaceId: string;
  workspaceUsers: string[];
};
export type AssignWorkspaceRoleDto = {
  workspaceId: string;
  username: string;
  access: "WORKSPACE_MANAGER" | "WORKSPACE_USER";
};
export type DeleteWorkspaceUserDto = {
  workspaceId: string;
  username: string;
};
export type WorkspaceUserRo = {
  usernames: any[];
};
export type CreateNewFolderWorkspaceDto = {
  folderName: string;
  workspaceId: string;
};
export type AddFolderToFolderDto = {
  folderName: string;
  rootFolderId: string;
  workspaceId: string;
};
export type RenameFolderWorkspaceDto = {
  folderName: string;
  workspaceId: string;
  folderId: string;
};
export type PreviewFolderRo = {
  id: string;
  name: string;
};
export type TaskWorkspaceRo = {
  id: string;
  name: string;
  isDeleted?: boolean;
};
export type RestoreTaskDto = {
  id: string;
  workspaceId?: string;
};
export type AssignTaskDto = {
  id: string;
  /** Workspace member username. Null to clear assignee. */
  assigneeId?: string | null;
};
export type TaskRo = {
  id: string;
  creator: string;
  assigneeId?: string | null;
  name: string;
  numberOfPages: number;
  manualCheckPages?: number;
  state:
    | "CREATE_IMAGES"
    | "CREATING_IMAGES"
    | "PENDING"
    | "PROCESSING"
    | "PREPARING"
    | "PARTIAL_READY"
    | "READY"
    | "READY_WITH_ERRORS"
    | "ERROR";
  outputState:
    | "NOT_GENERATED"
    | "GENERATE_OUTPUT"
    | "GENERATING_OUTPUT"
    | "GENERATED_OUTPUT"
    | "OUTDATED_OUTPUT"
    | "ERROR";
  createdAt: string;
  isDeleted?: boolean;
  deletedAt?: boolean;
  description: string;
  workspace?: TaskWorkspaceRo;
  setting: SettingRo;
  /** Sum of page boxRevision (legacy; unused after paddle-only ink). */
  boxRevision?: number;
  aiRefinedAt?: string | null;
  /** Whether "remove all suggestions on this page" is offered: false for documents created before review decisions were logged (SUGGESTION_AUDIT_CUTOFF in page-suggestions.ts). */
  canClearPageSuggestions?: boolean;
  stuckStage?: "image" | "ai" | "output";
  userDisplay?: {
    [key: string]: UserDisplayRo;
  };
};
export type ArchiveTaskRo = TaskRo & {
  folderId?: string | null;
  folderName?: string | null;
};
export type ArchivePageRo = {
  items: ArchiveTaskRo[];
  total: number;
  page: number;
  limit: number;
  /** True when OCR search hit the result or timeout cap */
  capped: boolean;
};
export type FolderRo = {
  id: string;
  name: string;
  folders: PreviewFolderRo[];
  tasks: TaskRo[];
};
export type RemoveFolderWorkspaceDto = {
  workspaceId: string;
  folderId: string;
};
export type ProcessingStageRo = {
  startedAt: string | null;
  finishedAt: string | null;
  lastBatchStartedAt: string | null;
  lockedAt: string | null;
  attempts: number;
  totalBatchDurationMs: number;
  averageBatchDuration: number | null;
};
export type TaskProcessingRo = {
  image: ProcessingStageRo;
  ai: ProcessingStageRo;
  result: ProcessingStageRo;
  output: ProcessingStageRo;
  finishedAt: string | null;
  failedAt: string | null;
};
export type TaskProgressRo = {
  progress: TaskProcessingRo;
  percent: number;
  stage: string;
  state?:
    | "READY"
    | "CREATE_IMAGES"
    | "CREATING_IMAGES"
    | "PENDING"
    | "PROCESSING"
    | "PREPARING"
    | "PARTIAL_READY"
    | "READY_WITH_ERRORS"
    | "ERROR";
  label: string;
  image: object;
  ai: object;
  stuckStage?: "image" | "ai" | "output" | null;
};
export type IdsDto = {
  ids: string[];
};
export type BoxRo = {
  id: string;
  text?: string;
  rect: any[];
};
export type ItemRo = {
  id: string;
  text?: string;
  boxes: BoxRo[];
  accuracy: number;
  redact: boolean;
  custom: boolean;
  tag?:
    | "PERSON"
    | "LOCATION"
    | "ORGANIZATION"
    | "PHONE"
    | "EMAIL"
    | "DATE"
    | "NAME"
    | "LINK"
    | "SIGNATURE";
  legalCode: string;
};
export type AddItemDto = {
  taskId: string;
  pageNumber: number;
  boxesId: string[];
};
export type AddCustomBoxDto = {
  taskId: string;
  pageNumber: number;
  rect: any[];
  text?: string;
};
export type ItemsRo = {
  items: ItemRo[];
};
export type UpdateBoxDto = {
  boxId: string;
  taskId: string;
  rect: any[];
};
export type ChangeRedactStateDto = {
  itemId: string;
  isRedact: boolean;
  taskId?: string;
};
export type DeleteItemDto = {
  id: string;
  taskId?: string;
};
export type GenerateOutputDto = {
  id: string;
  itemIds?: string[];
};
export type VerifyDto = {
  id: string;
  isVerify: boolean;
};
export type TasksStateRo = {
  tasksState: (
    | "CREATE_IMAGES"
    | "CREATING_IMAGES"
    | "PENDING"
    | "PROCESSING"
    | "PREPARING"
    | "PARTIAL_READY"
    | "READY"
    | "READY_WITH_ERRORS"
    | "ERROR"
  )[];
};
export type TaskOutputStateRo = {
  outputState:
    | "NOT_GENERATED"
    | "GENERATE_OUTPUT"
    | "GENERATING_OUTPUT"
    | "GENERATED_OUTPUT"
    | "OUTDATED_OUTPUT"
    | "ERROR";
  stuckStage?: "image" | "ai" | "output" | null;
};
export type CurrentPageRo = {
  index: number;
};
export type SetTaskCurrentPageDto = {
  id: string;
  index: number;
};
export type CreateLegalCodeDto = {
  legalCode: string;
  itemId: string;
  taskId: string;
};
export type RemoveLegalCodeDto = {
  itemId: string;
  taskId: string;
};
export type PageRo = {
  imagePath: string;
  aspectRatio: number;
  width?: number;
  height?: number;
  displayImagePath?: string;
  displayWidth?: number;
  thumbnailImagePath?: string;
  thumbnailWidth?: number;
  needsManualCheck?: boolean;
  manualCheckReason?: string;
  manualCheckChars?: number;
};
export type RedactAllDto = {
  taskId: string;
  word: string;
};
export type ItemsRedactStateDto = {
  taskId: string;
  itemIds: any[];
  isRedact: boolean;
};
export type Pdf2ImgTasksRo = {
  small_tasks: Pdf2ImgTasksRo[];
  large_tasks: Pdf2ImgTasksRo[];
};
export type Pdf2ImgPageDto = {
  imagePath: string;
  aspectRatio: number;
};
export type Pdf2ImgTaskResultDto = {
  id: string;
  pages: Pdf2ImgPageDto[];
};
export type AiTasksRo = {
  small_tasks: string[];
  large_tasks: string[];
};
export type AiBoxDto = {
  text?: string;
  rect: string[];
};
export type AiItemDto = {
  text?: string;
  boxes: AiBoxDto[];
  redact: boolean;
  accuracy: number;
  tag?:
    | "PERSON"
    | "LOCATION"
    | "ORGANIZATION"
    | "PHONE"
    | "EMAIL"
    | "DATE"
    | "NAME"
    | "LINK"
    | "SIGNATURE";
};
export type AiItemsDto = {
  items: AiItemDto[];
  index: number;
};
export type AiResultDto = {
  id: string;
  pages: AiItemsDto[];
};
export type GeneratingBoxRo = {
  rect: any[];
};
export type GeneratingItemRo = {
  boxes: GeneratingBoxRo[];
  redact: boolean;
  legalCode: string;
  legalCodeLabel?: string;
};
export type GeneratingPageRo = {
  items: GeneratingItemRo[];
  imagePath: string;
};
export type PdfGeneratingTaskRo = {
  id: string;
  name: string;
  pages: GeneratingPageRo[];
};
export type GeneratingResultDto = {
  id: string;
  outFilePath: string;
};
export type UsageHistoryRo = {
  periodKey: string;
  periodStart: string;
  periodEnd: string;
  pageCount: number;
  taskCount: number;
  maxPages: number;
};
export type UsageRo = {
  taskCount: number;
  pageCount: number;
  workspaceCount: number;
  maxPages?: number;
  maxUsers?: number;
  activeUsersCount?: number;
  expirationTime?: string;
  periodStart?: string;
  periodEnd?: string;
  periodKey?: string;
  subscriptionStatus?: string;
  paymentIssue?: boolean;
  billingSuspended?: boolean;
  history?: UsageHistoryRo[];
};
export type NotificationMetaRo = {
  taskId?: string;
  workspaceId?: string;
};
export type NotificationRo = {
  to: string;
  from: string;
  title: string;
  text: string;
  date: string;
  id: string;
  link?: string;
  meta?: NotificationMetaRo;
};
export type CreateCompanyNotificationDto = {
  title: string;
  text: string;
};
export type CreateNotificationDto = {
  to: string[];
  title: string;
  text: string;
};
export type NotificationPreviewRo = {
  to: string;
  from: string;
  title: string;
  text: string;
  date: string;
  id: string;
  link?: string;
  meta?: NotificationMetaRo;
};
export type NotificationCountRo = {
  notificationCount: number;
};
export type LicenseDetailRo = {
  serverId: string;
  licenseId: string;
  product: string;
  licensePlan: "NORMAL" | "PRO" | "ULTIMATE" | "TRIAL";
  maxUsers: number;
  maxPages: number;
  expirationTime: string;
  issuanceDate: string;
};
export type LicenseRo = {
  serverId: string;
  licenseDetail: LicenseDetailRo | null;
  licenseUploadDate: string | null;
};
export type LicenseDto = {
  license: string;
};
export type UpdateCompanyDto = {
  companyId: string;
  maxUsers: number;
  maxPages: number;
  expirationTime: string;
};
export type ScopeObjectRo = {
  id: string;
  name: string;
};
export type WordListType = "blacklist" | "whitelist";
export type WordScope = "personal" | "organisation";
export type WordRo = {
  id: string;
  creator: string;
  word: string;
  listType: WordListType;
  scope: WordScope;
  tag?: "PERSON" | "LOCATION" | "ORGANIZATION" | "PHONE" | "EMAIL" | "DATE" | "BSN" | "IBAN";
  workspaces: ScopeObjectRo[];
  companies: ScopeObjectRo[];
  isGlobal: boolean;
  language?: "EN" | "NL" | "FR" | "IT" | "DE" | "ES" | "PT" | "ZHS" | "ZHT";
};
export type CreateWordDto = {
  word: string;
  listType: WordListType;
  scope?: WordScope;
  companyIds?: string[];
};
export type UpdateWordDto = {
  word?: string;
  listType?: WordListType;
  companyIds?: string[];
};
export type FallbackLogRo = {
  level: string;
  message: string;
  body: string;
  sent: boolean;
};

export type LegalCodeControllerFindMyApiResponse = /** status 200  */ CompanyLegalCodeRo[];
export type LegalCodeControllerFindMyApiArg = {
  locale?: "EN" | "NL" | "FR" | "IT" | "DE" | "ES" | "PT" | "ZHS" | "ZHT";
};
export type LegalCodeControllerCreateApiResponse = /** status 200  */ CompanyLegalCodeRo;
export type LegalCodeControllerCreateApiArg = {
  createCompanyLegalCodeDto: CreateCompanyLegalCodeDto;
};
export type LegalCodeControllerUpdateApiResponse = /** status 200  */ CompanyLegalCodeRo;
export type LegalCodeControllerUpdateApiArg = {
  id: string;
  updateCompanyLegalCodeDto: UpdateCompanyLegalCodeDto;
};
export type LegalCodeControllerSetDefaultApiResponse = /** status 200  */ CompanyLegalCodeRo;
export type LegalCodeControllerSetDefaultApiArg = {
  id: string;
};
export type LegalCodeControllerRemoveApiResponse = unknown;
export type LegalCodeControllerRemoveApiArg = {
  id: string;
  deleteCompanyLegalCodeDto?: DeleteCompanyLegalCodeDto;
};
export type CompanyLegalCodeRo = {
  id: string;
  company: string;
  code: string;
  label: string;
  description: string;
  locale: "EN" | "NL" | "FR" | "IT" | "DE" | "ES" | "PT" | "ZHS" | "ZHT";
  isDefault: boolean;
  sort: number;
};
export type CreateCompanyLegalCodeDto = {
  code: string;
  label: string;
  description?: string;
  locale: "EN" | "NL" | "FR" | "IT" | "DE" | "ES" | "PT" | "ZHS" | "ZHT";
  isDefault?: boolean;
  sort?: number;
};
export type UpdateCompanyLegalCodeDto = {
  code?: string;
  label?: string;
  description?: string;
  isDefault?: boolean;
  sort?: number;
};
export type DeleteCompanyLegalCodeDto = {
  remapToDefault?: boolean;
};

export type TokenDto = {
  token: string;
};
export type DemoRo = {
  token: string;
  user: object;
};
export const {
  useUsersControllerCreateMutation,
  useUsersControllerUpdateMutation,
  useUsersControllerFindQuery,
  useUsersControllerDeleteMutation,
  useUsersControllerCreateCompanyUserMutation,
  useUsersControllerFindCompanyUsersQuery,
  useUsersControllerGetUserProfileQuery,
  useUsersControllerUpdateUserProfileMutation,
  useUsersControllerSuspendMutation,
  useUsersControllerActivateMutation,
  useUsersControllerAssignRoleMutation,
  useUsersControllerMailResetPasswordMutation,
  useUsersControllerCheckResetPasswordCredQuery,
  useUsersControllerResetPasswordMutation,
  useUsersControllerChangePasswordMutation,
  useUsersControllerConfirmEmailChangeMutation,
  useUsersControllerGetCompaniesQuery,
  useUsersControllerUpdateCompanyLicenseMutation,
  useUsersControllerGetCompanyUsersQuery,
  useUsersControllerGetNotOwnerUsersQuery,
  useCompaniesControllerFindAllQuery,
  useCompaniesControllerCreateMutation,
  useCompaniesControllerDeleteMutation,
  useAuthControllerLoginMutation,
  useAuthControllerSignupMutation,
  useTwoFactorAuthControllerGenerateTwoFactorQuery,
  useTwoFactorAuthControllerEnableTwoFactorMutation,
  useTwoFactorAuthControllerDisableTwoFactorMutation,
  useTwoFactorAuthControllerSendDisableTwoFactorCodeMutation,
  useRolesControllerCreateRoleMutation,
  useRolesControllerUpdateRoleMutation,
  useRolesControllerReadRoleQuery,
  useRolesControllerDeleteRoleMutation,
  useRolesControllerFindRoleQuery,
  useMediaControllerUploadDocumentMutation,
  useWorkspacesControllerGetWorkspaceByIdQuery,
  useWorkspacesControllerGetMyWorkspacesQuery,
  useWorkspacesControllerCreateWorkspaceMutation,
  useWorkspacesControllerUpdateWorkspaceMutation,
  useWorkspacesControllerDeleteWorkspaceMutation,
  useWorkspacesControllerGetCompanyWorkspacesQuery,
  useWorkspacesControllerInviteUserToWorkspaceMutation,
  useWorkspacesControllerAssignWorkspaceRoleMutation,
  useWorkspacesControllerDeleteWorkspaceUserMutation,
  useWorkspacesControllerFindWorkspaceUserQuery,
  useWorkspacesControllerCreateNewFolderMutation,
  useWorkspacesControllerAddFolderToMutation,
  useWorkspacesControllerRenameFolderMutation,
  useWorkspacesControllerGetFolderByIdQuery,
  useWorkspacesControllerGetRootFolderQuery,
  useWorkspacesControllerRemoveFolderMutation,
  useWorkspacesControllerDeleteFolderMutation,
  useTasksControllerGetTaskQuery,
  useTasksControllerGetMyRemovedTasksQuery,
  useTasksControllerGetArchiveQuery,
  useTasksControllerGetTaskProgressMutation,
  useTasksControllerProgressStreamQuery,
  useTasksControllerSetAssigneeMutation,
  useTasksControllerRemoveMutation,
  useTasksControllerRestoreMutation,
  useTasksControllerEmptyTrashMutation,
  useTasksControllerDeleteMutation,
  useTasksControllerDeleteCompanyTasksMutation,
  useTasksControllerRemoveManyMutation,
  useTasksControllerGetCompanyTasksQuery,
  useTasksControllerAddItemMutation,
  useTasksControllerDeleteItemMutation,
  useTasksControllerAddCustomBoxMutation,
  useTasksControllerGetItemsQuery,
  useTasksControllerUpdateBoxMutation,
  useTasksControllerChangeRedactStateMutation,
  useTasksControllerGetLastModifiedTasksQuery,
  useTasksControllerChangeVerifyMutation,
  useTasksControllerGenerateOutputMutation,
  useTasksControllerGetTasksStateQuery,
  useTasksControllerGetTaskOutputStateQuery,
  useTasksControllerSearchQuery,
  useTasksControllerGetPagesItemsQuery,
  useLazyTasksControllerGetPagesItemsQuery,
  useTasksControllerGetTaskCurrentPageQuery,
  useTasksControllerSetTaskCurrentPageMutation,
  useTasksControllerCreateLegalCodeMutation,
  useTasksControllerRemoveLegalCodeMutation,
  useTasksControllerGetTaskPagesUrlQuery,
  useTasksControllerGetTaskOutFileUrlQuery,
  useTasksControllerRedactAllMutation,
  useTasksControllerUnRedactAllMutation,
  useTasksControllerChangeItemsRedactStateMutation,
  useTasksInternalControllerGetPdf2ImgTaskMutation,
  useTasksInternalControllerSetPdf2ImgTaskResultMutation,
  useTasksInternalControllerGetAiTasksMutation,
  useTasksInternalControllerSetAiTasksMutation,
  useTasksInternalControllerSetAiRefineResultMutation,
  useTasksInternalControllerGetGeneratingTasksMutation,
  useTasksInternalControllerSetGeneratingTasksMutation,
  useLimitAndUsageControllerGetUsageQuery,
  useLimitAndUsageControllerGetCompanyUsageQuery,
  useLimitAndUsageControllerGetMyUsageQuery,
  useNotificationControllerCreateMyCompanyNotificationMutation,
  useNotificationControllerCreateNotificationMutation,
  useNotificationControllerCreateCompanyNotificationMutation,
  useNotificationControllerGetAllNotificationQuery,
  useNotificationControllerGetUnseenNotificationQuery,
  useNotificationControllerGetPreviewUnseenNotificationQuery,
  useNotificationControllerGetUnseenNotificationCountQuery,
  useNotificationControllerGetNotificationQuery,
  useNotificationControllerSeenNotificationMutation,
  useLicenseControllerUploadLicenseMutation,
  useLicenseControllerGetLicenseInformationQuery,
  useLicenseControllerLicenseUpdateMutation,
  useWordTaggerControllerCreateMutation,
  useWordTaggerControllerFindAllQuery,
  useWordTaggerControllerFindMyWordsQuery,
  useWordTaggerControllerFindOneQuery,
  useWordTaggerControllerUpdateMutation,
  useWordTaggerControllerRemoveMutation,
  useLoggingControllerGetAllLogsQuery,
  useLoggingControllerGetAllUnsentLogsQuery,
  useLoggingControllerSendAllUnsentLogsMutation,
  useDemoControllerUploadDemoMutation,
  useDemoControllerQuickUploadDemoMutation,
  useDemoControllerStartDemoMutation,
  useDemoControllerExchangeTokenMutation,
  useLegalCodeControllerFindMyQuery,
  useLazyLegalCodeControllerFindMyQuery,
  useLegalCodeControllerCreateMutation,
  useLegalCodeControllerUpdateMutation,
  useLegalCodeControllerSetDefaultMutation,
  useLegalCodeControllerRemoveMutation,
} = api;

